import script from "./WarehouseDatatableActionsWarehouse.vue?vue&type=script&setup=true&lang=js"
export * from "./WarehouseDatatableActionsWarehouse.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__